<script>
    import AuthService from "../../services/AuthService";
    import ChangePassword from "./ChangePassword";
    import {mapMutations} from "vuex";

    export default {
        name: "ForgotPasswordFinish",
        mixins: [ChangePassword],

        computed: {
            token() {
                return this.$route.params.token;
            },
        },

        methods: {
            actionSubmit() {
                this.loadingState = true;
                let password = this.$refs.password.value ?? '';
                let repeatPassword = this.$refs.repeatPassword.value ?? '';

                this.$api.newPassword({
                    data: {
                        token: this.token,
                        password: password,
                        repeatPassword: repeatPassword,
                    }
                }).then(({data}) => {
                    AuthService.login(data)

                    /* Delay for setting cookies */
                    setTimeout(() => {
                        this.redirectUserToTheOldAppOrDashboard();
                    }, 10);
                }).finally(() => {
                    this.loadingState = false;
                });
            },
            ...mapMutations('app', {
                setGlobalLoadingState: 'setGlobalLoadingState',
            }),

        },
        mounted() {
            this.$api.validateResetToken({
                segments: {
                    token: this.token
                }
            }).catch(() => {
                this.actionBackToLogin();
            }).finally(() => {
                this.setGlobalLoadingState(false);
            });

        }
    }
</script>
